<template>
  <div class="sorters-dropdown-container">
    <div class="sorters-container">
      <div @click="open">
        <span class="text">Sort by: </span>
        <span class="sort-icon">
          <svgicon name="sort-arrows" width="24" height="24" />
        </span>
      </div>
    </div>
    <div
      class="sorters-modal"
      :class="{ nondisplay: !openModal }"
    >
      <div class="sorters-modal-nav" />
      <div>
        <div
          v-for="sorter in options"
          :key="sorter.value"
          class="sorters-modal-content"
          :class="{ selected: curSorter.value === sorter.value }"
          @click="choose(sorter)"
        >
          {{ sorter.label }}
        </div>
      </div>
    </div>
    <div
      class="sorters-overlay"
      :class="{nondisplay: !openModal}"
      @click="close"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import { delay } from "~/helpers/ui"
import promoMixin from  '~/mixins/promoMixin.js'
import { mapGetters } from 'vuex'

export default {
  name: 'SortersDropDown',
  mixins: [promoMixin],
  props: {
    options: {
      type: Array,
      required: true
    },
    tourList: Array
  },
  computed: {
    ...mapGetters([
      'curSorter'
    ])
  },
  data () {
    return {
      openModal: false
    }
  },
  methods: {
    open () {
      delay(() => {
        this.openModal = true
      });
    },
    close () {
      delay(() => {
        this.openModal = false
      });
    },
    choose(el) {
      delay(() => {
        this.$store.commit("setSorter", el);
        this.openModal = false;
        this.$nextTick(() => {
          let impressionsTours = [];
          this.tourList.forEach((tour, i) => {
            impressionsTours.push({
              name: tour.titleShort,
              id: tour.bookingTypeId,
              price: this.getAnchorPriceNum(tour),
              category:
                tour.citySlug
                  .replace("-tours", "")
                  .charAt(0)
                  .toUpperCase() + tour.citySlug.replace("-tours", "").slice(1),
              list: "Listing Pages - " + this.curSorter.label,
              position: i + 1
            });
          });
          let dataGroup = {};
          this.chunkArray(impressionsTours, 3).forEach((group, i) => {
            dataGroup["group" + (i + 1)] = group;
          });
          Vue.localStorage.set("filters", this.curSorter.label);
          window.dataLayer.push({
            event: "sortOptionClick",
            click: {
              clickText: this.curSorter.label
            },
            ecommerce: {
              currencyCode: "USD",
              impressions: dataGroup
            }
          });
        });
      });
    },
    chunkArray (myArray, chunkSize) {
      var index = 0
      var arrayLength = myArray.length
      var tempArray = []
      for (index = 0; index < arrayLength; index += chunkSize) {
        var myChunk = myArray.slice(index, index + chunkSize)
        tempArray.push(myChunk)
      }
      return tempArray
    }
  }
}
</script>

<style lang="scss" scoped>
.sorters-dropdown-container {
  position: relative;
  display: flex;
  justify-content: center;
  .nondisplay {
    display: none;
  }
  @extend %subtitle-2-bold;
  .sorters-container {
    display: flex;
    align-items: center;

    cursor: pointer;
    user-select: none;
    position: relative;

    .text {
      color: $woi-red-main;
    }
    .sorter-button {
      width: 176px;
      height: 40px;
      margin: 0 8px;
      padding: 7px 12px;
      padding-left: 18px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: 2px solid #c8d1d8;
      border-radius: 8px;
      .arrow {
        border: solid #443c47;
        border-width: 0 2px 2px 0;
        display: inline-block;
        padding: 3px;
        &.down {
          transition: transform 0.2s, bottom 0.2s;
          transform: rotate(45deg);
          -webkit-transform: rotate(45deg);
        }
      }
      &:hover {
        cursor: pointer;
      }
      &.clicked {
        background-color: #f7f7f7;
      }
      &.long {
        padding-left: 8px;
      }
    }

    .sort-icon {
      margin-left: 8px;
      color: $woi-red-main;
    }

    padding: 10px 5px !important;

    &:before {
      content: "";
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      position: absolute;

      opacity: 0;
      z-index: 30;
      pointer-events: none;
      transition: opacity 0.5s;
      border-radius: 5px;
      background-color: rgba(0, 0, 0, 0.1);
    }

    &:active:before {
      opacity: 1;
    }
  }

  .sorters-modal {
    position: fixed;
    bottom: 0;
    left: 0;
    margin: 0;
    width: 100vw;
    z-index: 1112;
    background-color: $white;
    .sorters-modal-nav {
      padding: 20px 16px;
      background-color: $woi-red-main;
    }

    .sorters-modal-content {
      cursor: pointer;
      user-select: none;
      position: relative;

      margin: 8px 20px;
      width: auto;
      padding: 6px 8px;
      border-radius: 4px;
      color: $woi-red-main;

      &.selected {
        color: $woi-gold-main;
      }

      &:before {
        content: "";
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        position: absolute;

        opacity: 0;
        z-index: 30;
        pointer-events: none;
        transition: opacity 0.5s;
        background-color: rgba(0, 0, 0, 0.1);
      }

      &:active:before {
        opacity: 1;
      }
    }
  }
  .sorters-overlay {
    position: fixed;
    width: 100vw;
    height: 100vh;
    z-index: 5;
    top: 0;
    left: 0;
    background-color: $overlay-bg;
  }
}
</style>
